import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
import errorservice from './errorservice.js'
const controller = 'Kraken'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetAllMarcas: function (tipoVeiculo) {
    const dto = {
      parameters: [
        { name: 'tipoVeiculo', value: tipoVeiculo }
      ]
    }
    return util.Axios.GetAll(controller + '/GetAllMarcas', dto)
  },
  GetAllModeloPorMarca: function (tipoVeiculo, marca) {
    const dto = {
      parameters: [
        { name: 'tipoVeiculo', value: tipoVeiculo },
        { name: 'marca', value: marca }
      ]
    }
    return util.Axios.GetAll(controller + '/GetAllModeloPorMarca', dto)
  },
  GetValoresPorMarcaModelo: function (tipoVeiculo, marca, modelo) {
    const dto = {
      parameters: [
        { name: 'tipoVeiculo', value: tipoVeiculo },
        { name: 'marca', value: marca },
        { name: 'modelo', value: modelo }
      ]
    }
    return util.Axios.GetAll(controller + '/GetValoresPorMarcaModelo', dto)
  },
  GetAllGravames: function () {
    return util.Axios.GetAll(controller + '/GetAllGravames', {})
  },
  GravameIsLoading: false,
  GetValorGravame: function (tipo, uf, callback, tentativas) {
    const ctrl = this

    if (!tipo || !uf || ctrl.GravameIsLoading) {
      callback(0)
      return
    }

    if (!tentativas) { tentativas = 0 }

    this.GravameIsLoading = true
    if (ctrl.ListaGravame && ctrl.ListaGravame.length > 0) {
      validate()
    } else {
      ctrl.GetAllGravames().then(function (response) {
        ctrl.ListaGravame = response
        validate(response)
      })
    }

    function validate (response) {
      ctrl.GravameIsLoading = false
      if (!ctrl.ListaGravame || !ctrl.ListaGravame.length) {
        ctrl.ListaGravame = []
      } else if (tipo && callback && typeof callback === 'function') {
        const gravame = ctrl.ListaGravame.find(p => p.uf === uf)
        const value = gravame['valorTipo' + tipo]
        if (value) {
          callback(value)
          return
        }
      }

      tentativas++
      if (tentativas < 10) {
        errorservice.RegisterError(response)
        setTimeout(function () {
          ctrl.GetValorGravame(tipo, uf, callback, tentativas)
        }, 10)
      } else {
        ui.ShowError('Não foi possível recuperar os valores de gravame. Atualize a página e tente novamente.')
      }
    }
  },
  GetAllGravamePorUf: function (uf) {
    if (!uf) { return }
    const dto = {
      parameters: [
        { name: 'uf', value: uf }
      ]
    }
    return util.Axios.GetAll(controller + '/GetAllGravamePorUf', dto)
  },
  ListaGravame: []
})
